export const SITE_TYPES = {
  ALL: 'All',
  RESTAURANT: 'restaurant',
  HOTEL: 'hotel'
};
